import * as fetcher from "../helpers/fetcher";

export async function sendOrder(
  email,
  phone,
  deliveryAddress,
  meals = [],
  paymentMethod,
  timeOfDelivery,
  promoCode,
  note,
  token,
  idempotencyKey
) {
  const formattedMeals = meals
    .filter((meal) => meal.isCombo === false)
    .map((meal) => {
      return {
        mealId: meal.id,
        amount: meal.amount,
        ...(meal.chosenWeight != null
          ? { chosenWeight: meal.chosenWeight }
          : {}),
      };
    });
  const formattedComboMeals = meals
    .filter((meal) => meal.isCombo === true)
    .map((meal) => {
      return {
        comboMealId: meal.id,
        amount: meal.amount,
      };
    });

  return fetcher.post(
    `/orders`,
    {
      Authorization: `Bearer ${token}`,
      ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
    },
    {
      email: email,
      phoneNumber: phone,
      deliveryAddress: deliveryAddress,
      meals: formattedMeals,
      comboMeals: formattedComboMeals,
      paymentMethod:
        paymentMethod === 1 ? "CASH_ON_DELIVERY" : "CARD_ON_DELIVERY",
      timeOfDelivery: timeOfDelivery,
      ...(promoCode ? { promoCode } : {}),
      note: note,
    }
  );
}

export async function orderHistory(token) {
  return fetcher.get(`/orders/history`, { Authorization: `Bearer ${token}` });
}
